<script>
  import { _ } from 'svelte-i18n';
  import { link, location } from 'svelte-spa-router'
  import { info_client, client, list, pagination } from './stores'
  import { ordering as wikiOrdering, flowId as wikiFlowId } from '../components/stores'
  import active from 'svelte-spa-router/active'
  import { scrolledPublicationId } from './pages/Newsline/store';
  import { resetSearch } from './custom/GlobalSearch/services';

  const isMobileApp = JSON.parse(localStorage.getItem('from_mobile')) === true
  const isMobile = screen.width <= 576

  let currentRoute;
  $: currentRoute = $location;

  $: isUserFromUae = $info_client.flow?.is_uae || $client.flow?.settings?.for_uae;

  const clearList = () => {
    $list = []
    $pagination = null
    $wikiOrdering = ''
    $wikiFlowId = 0
  }

  const handleClick = (targetPath) => {
    if (currentRoute !== targetPath) {
      scrolledPublicationId.set('');
      resetSearch();
      clearList();
    }
  }
</script>

<div>
  <div class="main__navigation" style:margin-top={isMobile && !isMobileApp ? '50px' : '0px'}>
    {#if IS_SHOW_FEED && $info_client.has_feed_publications }
      <a 
        href="/listnews/feed_groops=physical_transformation"
        class="main__item text-bold active"
        use:link 
        use:active={{path: '/listnews/*', className: 'active'}}
        on:click={() => handleClick('/listnews/feed_groops=physical_transformation')}
      >
        <i class="icon-document" />
        {$_('Feed')}
      </a>
    {/if}

    {#if IS_SHOW_FLOW_PROGRAM && $info_client.show_flow_program && !$info_client.is_staff }
      <a 
        href="/flow-program" 
        class="main__item text-bold"
        use:link 
        use:active={{path: '/flow-program/', className: 'active'}}
        on:click={() => handleClick('/flow-program')}
      >
        <i class="icon-flow-program" />
        {$_('flowProgram')}
      </a>
    {/if}

    {#if IS_SHOW_WIKI && $info_client.has_wiki_publications }
      <a 
        href="/wiki/category" 
        class="main__item text-bold"
        use:link 
        use:active={{path: '/wiki/*', className: 'active'}}
        on:click={() => handleClick('/wiki/category')}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 2C6.72667 2 5.69533 2.92467 5.43733 4.12533C3.88267 4.40267 2.66667 5.7 2.66667 7.33333C2.66667 7.49733 2.68467 7.64333 2.70867 7.792C2.27867 8.424 2 9.16867 2 10C2 11.198 2.59667 12.206 3.43733 12.9373C3.37733 13.1747 3.33333 13.4113 3.33333 13.6667C3.33333 15.3153 4.68467 16.6667 6.33333 16.6667H6.37533C6.76333 17.4193 7.43533 18 8.33333 18C8.64441 17.9993 8.95218 17.9362 9.23845 17.8145C9.52472 17.6928 9.78368 17.5149 10 17.2913C10.2163 17.5149 10.4753 17.6928 10.7616 17.8145C11.0478 17.9362 11.3556 17.9993 11.6667 18C12.5653 18 13.2367 17.4193 13.6253 16.6667H13.6667C15.284 16.6667 16.6667 15.286 16.6667 13.6667C16.6667 13.4193 16.578 13.208 16.5207 12.9793C17.3853 12.2447 18 11.2193 18 10C18 9.16933 17.7213 8.42467 17.2913 7.79133C17.3153 7.64333 17.3333 7.498 17.3333 7.33333C17.3333 5.7 16.1173 4.40333 14.5627 4.12467C14.3047 2.92533 13.2733 2 12 2C11.2 2 10.4893 2.37267 10 2.93733C9.51067 2.37333 8.8 2 8 2ZM8 3.33333C8.74467 3.33333 9.33333 3.922 9.33333 4.66667V6C9.33333 7.112 8.44533 8 7.33333 8V9.33333C8.08867 9.33333 8.77333 9.07333 9.33333 8.646V15.6667C9.33333 16.2267 8.89333 16.6667 8.33333 16.6667C8.10009 16.6699 7.87332 16.5899 7.69381 16.4409C7.5143 16.292 7.39381 16.0838 7.354 15.854L7.22933 15.2087L6.58333 15.3127C6.34597 15.3502 6.10329 15.3356 5.8721 15.27C5.64092 15.2044 5.42675 15.0894 5.24445 14.9328C5.06214 14.7762 4.91604 14.5819 4.81628 14.3633C4.71651 14.1447 4.66546 13.907 4.66667 13.6667C4.66667 13.4607 4.7 13.268 4.77067 13.0833C4.776 13.068 4.78667 13.0567 4.79133 13.0413C4.89363 12.7872 5.05775 12.5626 5.26882 12.388C5.47988 12.2134 5.73121 12.0942 6 12.0413L5.72933 10.7293C5.04893 10.8637 4.43707 11.2322 4 11.7707C3.56654 11.2831 3.32904 10.6523 3.33333 10C3.33219 9.40049 3.53827 8.81901 3.91667 8.354L4.12533 8.104L4.06267 7.77067C4.02489 7.62781 4.00386 7.48105 4 7.33333C4 6.22133 4.888 5.33333 6 5.33333H6.66667V4.66667C6.66667 3.922 7.25533 3.33333 8 3.33333ZM12 3.33333C12.7447 3.33333 13.3333 3.922 13.3333 4.66667V5.33333H14C15.112 5.33333 16 6.22133 16 7.33333C16 7.47667 15.9733 7.61467 15.9373 7.77067L15.8753 8.104L16.0833 8.354C16.4617 8.81901 16.6678 9.40049 16.6667 10C16.6667 10.8 16.3253 11.5133 15.7707 12C15.3153 11.5967 14.7347 11.3333 14.0833 11.3333C13.4533 11.3333 12.8853 11.5573 12.4373 11.9373L13.292 12.9587C13.5119 12.7691 13.793 12.6654 14.0833 12.6667C14.7267 12.6667 15.2393 13.1487 15.3127 13.7707C15.258 14.6487 14.5573 15.3333 13.6667 15.3333C13.6067 15.3333 13.5333 15.3307 13.4167 15.3127L12.7707 15.208L12.646 15.8547C12.6061 16.0844 12.4855 16.2923 12.306 16.4412C12.1265 16.59 11.8998 16.67 11.6667 16.6667C11.1067 16.6667 10.6667 16.2267 10.6667 15.6667V8.646C11.239 9.08987 11.9424 9.33157 12.6667 9.33333V8C11.5547 8 10.6667 7.112 10.6667 6V4.66667C10.6667 3.922 11.2553 3.33333 12 3.33333Z" fill="#5A5F6D"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33332 18C7.43532 18 6.76332 17.4193 6.37532 16.6667H6.33332C4.68465 16.6667 3.33332 15.3153 3.33332 13.6667C3.33332 13.4113 3.37732 13.1747 3.43732 12.9373C2.59665 12.206 1.99999 11.198 1.99999 10C1.99999 9.16867 2.27865 8.424 2.70865 7.792C2.68465 7.64334 2.66665 7.49734 2.66665 7.33334C2.66665 5.7 3.88265 4.40267 5.43732 4.12534C5.69532 2.92467 6.72665 2 7.99999 2C8.72817 2 9.38234 2.30932 9.86295 2.79019C9.91035 2.83761 9.95606 2.88671 9.99999 2.93734C10.0439 2.88668 10.0896 2.83756 10.1369 2.79012C10.6176 2.3088 11.2718 2 12 2C13.2733 2 14.3047 2.92534 14.5627 4.12467C16.1173 4.40334 17.3333 5.7 17.3333 7.33334C17.3333 7.498 17.3153 7.64334 17.2913 7.79134C17.7213 8.42467 18 9.16934 18 10C18 11.2193 17.3853 12.2447 16.5207 12.9793C16.536 13.0407 16.5537 13.1009 16.5713 13.1608C16.6192 13.3241 16.6667 13.4857 16.6667 13.6667C16.6667 15.286 15.2839 16.6667 13.6667 16.6667H13.6253C13.2367 17.4193 12.5653 18 11.6667 18C11.3556 17.9993 11.0478 17.9362 10.7615 17.8145C10.5222 17.7127 10.3019 17.5717 10.1097 17.3975C10.072 17.3634 10.0354 17.328 9.99999 17.2913C9.96455 17.328 9.92796 17.3634 9.8903 17.3975C9.69808 17.5717 9.47781 17.7127 9.23844 17.8145C8.95217 17.9362 8.64439 17.9993 8.33332 18ZM9.99999 17.5677C9.79713 17.7467 9.56649 17.8923 9.3167 17.9985C9.00582 18.1307 8.67159 18.1992 8.33378 18.2C7.38242 18.2 6.67422 17.6108 6.2554 16.8657C4.53185 16.8239 3.13332 15.3997 3.13332 13.6667C3.13332 13.4327 3.16726 13.2157 3.21483 13.007C2.38928 12.254 1.79999 11.2247 1.79999 10C1.79999 9.15125 2.0754 8.39102 2.49914 7.74556C2.4803 7.61631 2.46665 7.4822 2.46665 7.33334C2.46665 5.63983 3.69395 4.29405 5.27263 3.95395C5.593 2.73227 6.67078 1.8 7.99999 1.8C8.7844 1.8 9.486 2.13236 9.99991 2.64433C10.5139 2.13179 11.2156 1.8 12 1.8C13.3292 1.8 14.407 2.73291 14.7273 3.95338C16.3059 4.29465 17.5333 5.6397 17.5333 7.33334C17.5333 7.48267 17.5197 7.61636 17.5009 7.74506C17.9245 8.39161 18.2 9.1518 18.2 10C18.2 11.2448 17.5944 12.2906 16.7466 13.0477C16.7508 13.0623 16.7552 13.0771 16.7596 13.0921L16.7633 13.105C16.7784 13.1561 16.7943 13.2104 16.8087 13.2655C16.8401 13.3858 16.8667 13.519 16.8667 13.6667C16.8667 15.3703 15.4387 16.8219 13.7452 16.8657C13.3259 17.6107 12.6188 18.2 11.6667 18.2C11.3288 18.1992 10.9942 18.1307 10.6833 17.9985C10.4335 17.8923 10.2029 17.7467 9.99999 17.5677ZM7.13332 8C7.13332 7.88955 7.22286 7.8 7.33332 7.8C8.33486 7.8 9.13332 7.00155 9.13332 6V4.66667C9.13332 4.03246 8.6342 3.53334 7.99999 3.53334C7.36578 3.53334 6.86665 4.03246 6.86665 4.66667V5.33334C6.86665 5.44379 6.77711 5.53334 6.66665 5.53334H5.99999C4.99932 5.53334 4.20138 6.3304 4.19999 7.33072C4.20362 7.46205 4.22242 7.59252 4.25601 7.71954C4.25725 7.72423 4.25832 7.72895 4.25921 7.73372L4.32188 8.06705C4.33291 8.12575 4.31714 8.18631 4.27886 8.23216L4.07102 8.48118C3.72221 8.91026 3.53227 9.44663 3.53332 9.99962L3.53332 10.0013C3.52985 10.5279 3.69689 11.0394 4.0062 11.4607C4.4566 10.9859 5.04464 10.6607 5.69057 10.5331C5.79828 10.5119 5.90301 10.5814 5.9252 10.6889L6.19586 12.0009C6.20664 12.0532 6.19609 12.1076 6.16656 12.152C6.13703 12.1965 6.09096 12.2273 6.0386 12.2376C5.80249 12.284 5.58171 12.3887 5.3963 12.5421C5.21226 12.6944 5.06885 12.8899 4.97886 13.1111C4.97443 13.1235 4.96964 13.1339 4.96554 13.1421C4.96137 13.1504 4.95721 13.1576 4.95486 13.1616C4.8954 13.3196 4.86665 13.4856 4.86665 13.6667V13.6677C4.86559 13.879 4.91048 14.088 4.99821 14.2803C5.08594 14.4725 5.21442 14.6434 5.37473 14.7811C5.53505 14.9188 5.72338 15.0199 5.92668 15.0776C6.12992 15.1353 6.34326 15.1481 6.55193 15.1151C6.55199 15.1151 6.55187 15.1152 6.55193 15.1151L7.19753 15.0112C7.30419 14.994 7.4052 15.0647 7.42569 15.1707L7.55109 15.8199C7.58277 16.0028 7.67864 16.1685 7.82152 16.287C7.96439 16.4056 8.14488 16.4693 8.33052 16.4667L8.33332 16.4667C8.78286 16.4667 9.13332 16.1162 9.13332 15.6667V9.0246C8.60729 9.34464 7.99628 9.53334 7.33332 9.53334C7.22286 9.53334 7.13332 9.44379 7.13332 9.33334V8ZM9.13332 8.78793C9.20161 8.74297 9.26831 8.69561 9.33332 8.646V15.6667C9.33332 16.2267 8.89332 16.6667 8.33332 16.6667C8.10007 16.6699 7.87331 16.5899 7.6938 16.4409C7.51429 16.292 7.3938 16.0839 7.35399 15.854L7.22932 15.2087L6.58332 15.3127C6.34595 15.3502 6.10327 15.3356 5.87209 15.27C5.64091 15.2044 5.42674 15.0894 5.24443 14.9328C5.06212 14.7762 4.91603 14.5819 4.81626 14.3633C4.7165 14.1447 4.66545 13.907 4.66665 13.6667C4.66665 13.4607 4.69999 13.268 4.77065 13.0833C4.77321 13.076 4.77699 13.0696 4.78075 13.0632C4.78483 13.0562 4.78889 13.0493 4.79132 13.0413C4.89361 12.7872 5.05774 12.5626 5.2688 12.388C5.47212 12.2198 5.7128 12.103 5.97046 12.0474C5.98028 12.0453 5.99012 12.0433 5.99999 12.0413L5.72932 10.7293C5.71293 10.7326 5.69657 10.7359 5.68026 10.7395C5.63128 10.75 5.58267 10.7617 5.53447 10.7747C4.99733 10.919 4.51142 11.2114 4.13241 11.6184C4.08668 11.6675 4.04251 11.7183 3.99999 11.7707C3.95468 11.7197 3.91151 11.6672 3.87053 11.6132C3.51951 11.151 3.32947 10.5842 3.33332 10C3.33218 9.40049 3.53826 8.81901 3.91665 8.354L4.12532 8.104L4.06265 7.77067C4.02488 7.62782 4.00385 7.48105 3.99999 7.33334C3.99999 6.22134 4.88799 5.33334 5.99999 5.33334H6.66665V4.66667C6.66665 3.922 7.25532 3.33334 7.99999 3.33334C8.74465 3.33334 9.33332 3.922 9.33332 4.66667V6C9.33332 7.112 8.44532 8 7.33332 8V9.33334C7.40056 9.33334 7.46724 9.33128 7.53332 9.32722C8.12338 9.29101 8.66576 9.09573 9.13332 8.78793ZM13.3333 5.53334C13.2229 5.53334 13.1333 5.44379 13.1333 5.33334V4.66667C13.1333 4.03246 12.6342 3.53334 12 3.53334C11.3658 3.53334 10.8667 4.03246 10.8667 4.66667V6C10.8667 7.00155 11.6651 7.8 12.6667 7.8C12.7771 7.8 12.8667 7.88955 12.8667 8V9.33334C12.8667 9.38646 12.8455 9.43741 12.8079 9.47493C12.7703 9.51245 12.7193 9.53346 12.6662 9.53334C12.0288 9.53179 11.4068 9.35514 10.8667 9.02627V15.6667C10.8667 16.1162 11.2171 16.4667 11.6667 16.4667H11.6695C11.855 16.4693 12.0355 16.4057 12.1783 16.2872C12.3212 16.1688 12.4171 16.0032 12.4489 15.8204L12.4496 15.8168L12.5743 15.1701C12.5947 15.064 12.6959 14.9933 12.8026 15.0106L13.4472 15.115C13.4474 15.115 13.4469 15.115 13.4472 15.115C13.5521 15.1312 13.6157 15.1333 13.6667 15.1333C14.4421 15.1333 15.0551 14.5436 15.1118 13.7764C15.0424 13.2596 14.615 12.8667 14.0833 12.8667C13.8412 12.8656 13.606 12.9521 13.4226 13.1102C13.382 13.1451 13.3291 13.1624 13.2757 13.158C13.2224 13.1537 13.173 13.1281 13.1386 13.087L12.2839 12.0657C12.2134 11.9814 12.2241 11.8559 12.308 11.7848C12.7907 11.3753 13.4042 11.1333 14.0833 11.1333C14.7244 11.1333 15.2989 11.3685 15.7627 11.733C16.2012 11.29 16.4667 10.6798 16.4667 10C16.4677 9.44696 16.2777 8.91016 15.9289 8.48106C15.9286 8.48078 15.9284 8.48051 15.9282 8.48024L15.7216 8.23192C15.6835 8.18619 15.6678 8.12591 15.6787 8.06743L15.7423 7.72566C15.7778 7.57188 15.8 7.45258 15.8 7.33334C15.8 6.33179 15.0015 5.53334 14 5.53334H13.3333ZM16.0833 8.354C16.4617 8.81901 16.6678 9.40049 16.6667 10C16.6667 10.8 16.3253 11.5133 15.7707 12C15.3153 11.5967 14.7347 11.3333 14.0833 11.3333C13.525 11.3333 13.0153 11.5093 12.5948 11.8138C12.5502 11.8461 12.5067 11.8798 12.4642 11.9148C12.4552 11.9223 12.4462 11.9298 12.4373 11.9373L13.292 12.9587C13.3009 12.951 13.3099 12.9435 13.3189 12.9361C13.5346 12.7609 13.8047 12.6655 14.0833 12.6667C14.7267 12.6667 15.2393 13.1487 15.3127 13.7707C15.258 14.6487 14.5573 15.3333 13.6667 15.3333C13.6067 15.3333 13.5333 15.3307 13.4167 15.3127L12.7707 15.208L12.646 15.8547C12.606 16.0844 12.4855 16.2923 12.306 16.4412C12.1265 16.59 11.8998 16.67 11.6667 16.6667C11.1067 16.6667 10.6667 16.2267 10.6667 15.6667V8.646C10.7317 8.69643 10.7984 8.74425 10.8667 8.78941C11.3437 9.105 11.8953 9.29042 12.4667 9.32674C12.5331 9.33097 12.5998 9.33317 12.6667 9.33334V8C11.5547 8 10.6667 7.112 10.6667 6V4.66667C10.6667 3.922 11.2553 3.33334 12 3.33334C12.7447 3.33334 13.3333 3.922 13.3333 4.66667V5.33334H14C15.112 5.33334 16 6.22134 16 7.33334C16 7.47667 15.9733 7.61467 15.9373 7.77067L15.8753 8.104L16.0833 8.354Z" fill="#5A5F6D"/>
        </svg>  
        {$_('PhTWiki')}
      </a>
    {/if}

    {#if !$info_client.flow?.is_green && !isUserFromUae && $info_client.has_community_publications }
      <a 
        href="/community/" 
        class="main__item text-bold"
        use:link 
        use:active={{path: '/community/*', className: 'active'}}
        on:click={() => handleClick('/community/')}
      >
        <i class="icon-community" />
        {$_('communityLink')}
      </a>
    {/if}
    
    {#if !$info_client.is_staff}
      <hr>  
    
      <a 
        href="/favorites" 
        class="main__item text-bold"
        use:link 
        use:active={{path: '', className: 'active'}}
        on:click={() => handleClick('/favorites')}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2H7.00001C6.20436 2 5.4413 2.31607 4.87869 2.87868C4.31608 3.44129 4.00001 4.20435 4.00001 5V17C3.99931 17.1762 4.04518 17.3495 4.13299 17.5023C4.22079 17.655 4.3474 17.7819 4.50001 17.87C4.65203 17.9578 4.82447 18.004 5.00001 18.004C5.17554 18.004 5.34799 17.9578 5.50001 17.87L10 14.69L14.5 17.87C14.6524 17.9564 14.8248 18.0012 15 18C15.1752 18.0012 15.3476 17.9564 15.5 17.87C15.6526 17.7819 15.7792 17.655 15.867 17.5023C15.9548 17.3495 16.0007 17.1762 16 17V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7957 2 13 2ZM14 15.27L10.5 12.67C10.348 12.5822 10.1755 12.536 10 12.536C9.82447 12.536 9.65203 12.5822 9.50001 12.67L6.00001 15.27V5C6.00001 4.73478 6.10536 4.48043 6.2929 4.29289C6.48044 4.10536 6.73479 4 7.00001 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8947 4.48043 14 4.73478 14 5V15.27Z" fill="#5A5F6D" fill-opacity="0.6"/>
        </svg>       
        {$_('favorites')}
      </a>
    {/if}
  </div>
</div>

<style lang="scss">
  hr {
    margin: 0 0 8px 0;

    @media (max-width: 576px) {
      display: none;
    }
  }

  a {
    text-decoration: none;
  }

  .main__navigation {
    display: flex;
    position: fixed;
    flex-direction: column;
    max-width: 195px;
    width: 100%;

    i {
      margin-right: 8px;
      font-size: 16px;

      @media (min-width: 320px) and (max-width: 1000px) {
        display: none;
      }
    }

    @media (min-width: 320px) and (max-width: 1000px) {
      display: -webkit-inline-box;
      position: static;
      flex-direction: row;
      justify-content: flex-start;
      margin-left: 0;
      width: 100%;
    }

    @media (max-width: 576px) {
      margin-bottom: 24px;
      overflow-x: scroll;
      max-width: initial;
    }
  }

  svg {
    padding-right: 7px;

    @media (max-width: 576px) {
      display: none;
    }
  }

  svg path {
    fill: currentColor;
    stroke:inherit;
    stroke-width:inherit;
  }

  .main__item {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    margin-bottom: 8px;
    border:none;
    font-size: 14px;
    line-height: 20px;
    color: rgba(90, 95, 109, 0.6); 
    background-color: white; 
    border-radius: 30px;
    padding: 10px ;
    cursor: pointer;
    fill:rgba(90, 95, 109, 0.6);
    opacity: .6;

    &:hover {
      background-color: #EEEEEE;
      color: #30333D;
      fill: #30333D;
      opacity: 1;
    }

    &.active {
      background-color: #EEEEEE;
      color: #30333D;
      fill: #30333D;
      opacity: 1;
    }

    @media (min-width: 320px) and (max-width: 1000px) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 167px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(90, 95, 109, 0.6); 
      border-bottom: 2px solid rgba(90, 95, 109, 0.6);
      border-radius: 0;
      margin-bottom: 24px;
      fill: rgba(90, 95, 109, 0.6);

      &:hover {
        color: #2B50ED;
        background-color: white;
        border-bottom: 2px solid #2B50ED;
        opacity: 1;
        fill: #2B50ED;
      }

      &.active {
        color: #2B50ED;
        border-bottom: 2px solid #2B50ED;
        fill: #2B50ED;
        background-color: white;
      }
    }

    @media (max-width: 576px) {
      width: 126px;
      font-size: 12px;
      line-height: 18px;
      color: rgba(90, 95, 109, 0.6); 
      margin-bottom: 0;

      &.active {
        width: 126px;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 0;
      }
    }

    @media (max-width: 500px) {
      width: 120px;
      font-size: 12px;
      line-height: 18px;
      color: rgba(90, 95, 109, 0.6); 

      &.active {
        width: 120px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
</style>
